// import { ViewSupport49Component } from "../../../components/SupportSystem/ViewReports/ViewSupport49Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { OperationReport411Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport411Component";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
export function ViewSupport411Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-11)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport411Component />
            <Footer />
        </div>
    );
}
